import {
    clearMapBounds,
    setAuxMinimized,
    setAuxResourceName,
    setAuxResourceUrl,
    setExperienceMarker, setFooterOpen
} from "../helpers/commit_helpers";

export default function subMarkerClicked(sm, subMarker) {
    clearMapBounds(sm);
    setExperienceMarker(sm, subMarker.currentExperienceMarker);
    setAuxResourceName(sm, subMarker.currentExperienceMarker.experience.primaryName);
    setAuxResourceUrl(sm, subMarker.currentExperienceMarker.experience.url);
    setAuxMinimized(sm, false);
    setFooterOpen(sm, false);
    subMarker.onlineApp.aux.scrollTo();
}